import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import About from "./pages/About";
import Home from './pages/Home';
import Login from "./pages/Login";
import Products from './pages/Products';
import Page from './pages/static/Page';
import { useAppDispatch } from "./redux/hooks";
import { fetchProducts } from "./redux/reducers/productReducer";
import { authenticate } from "./redux/reducers/authReducer";
import Profile from "./pages/Profile";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import { fetchCategories } from "./redux/reducers/categoryReducer";
import Register from "./pages/Register";
import ProductItem from "./pages/ProductItem";

import './App.scss'
import Order from "./pages/Order";
import SearchPage from "./pages/SearchPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Page element={<Home />} />,
    
  },
  {
    path: "products",
    children: [
      {
        path: '',
        element:<Page element={<Products/>} />,
      },
      {
        path: ':id',
        element: <Page element={<ProductItem/>}/>
      }
    ]
  },
  {
    path: "about",
    element: <Page element={<About/>}/>,
  },
  {
    path: "login",
    element: <Page element={<Login/>}/>
  },
  {
    path: "profile",
    element: <Page element={<Profile/>}/>
  },
  {
    path: "contact",
    element: <Page element={<Contact/>}/>
  },
  {
    path: "cart",
    children: [
      {
        path: '',
        element: <Page element={<Cart/>}/>
      },
      {
        path: 'checkout',
        element: <Page element={<Order/>}/>
      }
    ]
  },
  {
    path: "register",
    element: <Page element={<Register/>}/>
  },
  {
    path: 'search',
    element: <Page element={<SearchPage/>}/>
  }
], {
  basename: '/bof-frontend-project-advanced'
});


function App() {
  const dispatch = useAppDispatch()
  useEffect(()=> {
    dispatch(fetchProducts())
    dispatch(fetchCategories())
    const token = localStorage.getItem('webToken')
    if(!!token) dispatch(authenticate(token))
  }, [dispatch])
  return (
      <RouterProvider router={router}/>
  );
}

export default App;
